/**
 * Sprint 56 — Dónde está corriendo el renderer.
 *
 * El mismo bundle de React se sirve en dos transportes (ver `index.tsx`):
 * Electron inyecta `window.api` desde el preload; en web se carga el shim HTTP.
 * Casi toda la app puede ignorar la diferencia, pero la impresión no: en
 * escritorio el proceso main manda el ticket a la térmica en silencio, y en web
 * eso es imposible porque el servidor corre en el VPS.
 */

type Modo = 'electron' | 'web';

let modo: Modo = 'electron';

/** La llama `index.tsx` cuando no hubo preload y tocó cargar el shim HTTP. */
export function marcarModo(nuevo: Modo): void {
  modo = nuevo;
}

/** true cuando la app se abrió desde un navegador (track web). */
export function esWeb(): boolean {
  return modo === 'web';
}
